import {Scene,ArcRotateCamera,AbstractMesh,AnimationGroup,Mesh} from '@babylonjs/core';
import { GlobalObject } from '../../utils/GlobalObject'
import { ModelLoader } from '../../loader/ModelLoader'

export class BasePlayer {
  public scene: Scene;
  public camera: ArcRotateCamera;
  public charactor?: AbstractMesh;
  public walkAnim?: AnimationGroup;
  public sitAnim?: AnimationGroup;
  public idleAnim?: AnimationGroup;
  public standAnim?: AnimationGroup;



  constructor(scene: Scene, camera: ArcRotateCamera) {
    this.scene = scene;
    this.camera = camera;
  }
  public async addCharactor(src: string) {
  }
  private parseAnimate(groups: any[]) {
    for (let i = 0; i < groups.length; ++i) {
      const an = groups[i];
      if (!an || !an.name) {
        continue;
      }
      if (an.name.indexOf('walk') > -1) {
        this.walkAnim = an;
      }
      if (an.name.indexOf('idle') > -1) {
        this.idleAnim = an;
      }
      if (an.name.indexOf('sitdown') > -1) {
        this.sitAnim = an;
      }
      if (an.name.indexOf('standup') > -1) {
        this.standAnim = an;
      }
    }
  }
  public getAnimate(act: string) {
    let an = this.idleAnim;
    switch (act) {
      case 'idle':
        an = this.idleAnim
        break;
      case 'walk':
        an = this.walkAnim
        break;
      case 'sit':
        an = this.sitAnim
        break;
      case 'stand':
        an = this.standAnim
        break;
      default:
        an = this.idleAnim
        break;
    }
    return an;
  }
}